import * as Constants from '../../../constants/Constants';

/**
 * @param {TimesGridState} state
 * @param {moment} startDate
 * @param {int} numDays
 */
export default function getApiV2Parameters(state, startDate, numDays) {
    return {
        professional_location_ids: state.doctorLocationIds,
        date: startDate.format(Constants.DATE_FORMAT),
        days_ahead: numDays,
        procedure_id: state.procedureId,
        availability_time_filter: state.availabilityTimeFilter,
        is_new_patient: !state.isExistingPatient,
        apikey: state.apikey,
    };
}
